import gql from 'graphql-tag';

export default gql`
  query GetEatery($id: ID!) {
    eatery(id: $id) {
      id
      createdAt
      updatedAt
      name
      status
      description
      logo
      email
      telephoneNumber
      whatsappNumber
      menus
      pdfs
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      tradingHours
      xtradingHours
      hyperlinks
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetEatery.ts